import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import SendIcon from '@material-ui/icons/Send';


export default function BasicTable({data}) {
console.log(data)


  return (
 <Order  {...data}/>
  )
}




const Order=({order,order_detail,appform,fee_parent_details})=>{

  return(
    <List disablePadding>

    <ListItem   >
      <ListItemText  >
<Typography variant="subtitle2">Application Form No.</Typography>
      </ListItemText>
      <Typography variant="body2">{appform.form_number}</Typography>
    </ListItem>
    <ListItem   >
    <ListItemText  >
<Typography variant="subtitle2">Course</Typography>
    </ListItemText>
      <Typography variant="body2">  {appform.course}</Typography>
    </ListItem>


    <ListItem   >
    <ListItemText  >
  <Typography variant="subtitle2">Phase</Typography>
    </ListItemText>
      <Typography variant="body2">  {appform.phase}</Typography>
    </ListItem>


    <ListItem   >
    <ListItemText  >
<Typography variant="subtitle2">Stream</Typography>
    </ListItemText>
      <Typography variant="body2">  {appform.stream}</Typography>
    </ListItem>


    <ListItem   >
    <ListItemText  >
<Typography variant="subtitle2">Class</Typography>
    </ListItemText>
      <Typography variant="body2">  {appform.class}</Typography>
    </ListItem>

    <ListItem   >
    <ListItemText  >
  <Typography variant="subtitle2">Enrollment Status</Typography>
    </ListItemText>
      <Typography variant="body2">  {appform.is_enrolled?'enrolled':'Not enrolled yet'}</Typography>
    </ListItem>


    <ListItem   >
    <ListItemText  >
  <Typography variant="subtitle2">Fee Details</Typography>
    </ListItemText>
     {/*<FeeParentDetails  {...fee_parent_details}/>
     <FeeChildDetails/>
     <AvailableFeeOptionBasedonLogic/>
*/}
    </ListItem>



    </List>
  )
}



const FeeParentDetails=({total_fee})=>{
  return(
    <span>Total Fee : &#8377; {total_fee}</span>
  )
}
